<script setup lang="ts">
import { toValue, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useConfigStore } from '../Stores/config'
import { Locale } from '../global'

const configStore = useConfigStore()
const { locale } = useI18n()

const language: Locale = toValue(locale) as Locale
const shouldShowPrivacyPolicy = computed(() => !configStore.isKbcOrEnergyAtHomePartner)
</script>

<template>
    <i18n-t
        keypath="privacy"
        tag="p"
        scope="global"
        class="text-sm text-neutral-500"
        v-if="shouldShowPrivacyPolicy"
    >
        <a
            :href="`/privacy-statement/${language}`"
            class="text-primary-800 underline underline-offset-2"
            target="_blank"
        >
            {{ $t('privacy statement') }}
        </a>
    </i18n-t>
</template>
